import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Store } from "@ngxs/store";
import { Navigate } from "@ngxs/router-plugin";

@Injectable({
  providedIn: "root",
})
export class LoggedInGuard implements CanActivate {
  constructor(private cookieService: CookieService, private store: Store) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.cookieService.get("user")) {
      this.store.dispatch(new Navigate(["/home"]));
      return false;
    } else {
      return true;
    }
  }
}
